import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CookieIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.00822 1.92022C8.00822 1.40421 7.6784 0.931464 7.17064 1.00822C5.19418 1.30701 1 2.5751 1 7.95704C1 11.8468 4.13769 15 8.00822 15C11.7104 15 14.7421 12.1151 14.9988 8.46025C15.0183 8.18311 14.7923 7.95711 14.5159 7.95711C13.1335 7.95711 12.0129 6.83089 12.0129 5.4417C12.0129 5.11703 11.7345 4.83738 11.4164 4.89421C11.2711 4.92018 11.1272 4.93863 11.0117 4.93863C9.35294 4.93863 8.00822 3.58724 8.00822 1.92022ZM5 5.75C5 6.16421 4.66421 6.5 4.25 6.5C3.83579 6.5 3.5 6.16421 3.5 5.75C3.5 5.33579 3.83579 5 4.25 5C4.66421 5 5 5.33579 5 5.75ZM11.75 11.5C12.1642 11.5 12.5 11.1642 12.5 10.75C12.5 10.3358 12.1642 10 11.75 10C11.3358 10 11 10.3358 11 10.75C11 11.1642 11.3358 11.5 11.75 11.5ZM9 7.75C9 8.16421 8.66421 8.5 8.25 8.5C7.83579 8.5 7.5 8.16421 7.5 7.75C7.5 7.33579 7.83579 7 8.25 7C8.66421 7 9 7.33579 9 7.75ZM5.75 11.5C6.16421 11.5 6.5 11.1642 6.5 10.75C6.5 10.3358 6.16421 10 5.75 10C5.33579 10 5 10.3358 5 10.75C5 11.1642 5.33579 11.5 5.75 11.5Z"
		></path>
	</svg>
))
